import { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import { initialSummary } from "../constants";
import { buildBreakdownQuery } from "../formatters";

export function useQbrSummary(filters, canLoadData) {
  const [summary, setSummary] = useState(initialSummary);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!canLoadData) {
      setSummary(initialSummary);
      return;
    }

    let cancelled = false;
    const controller = new AbortController();

    const fetchSummary = async () => {
      setIsSummaryLoading(true);
      try {
        const params = buildBreakdownQuery(filters).toString();
        const response = await apiClient.get(`/api/v1/difotVisualisation/summary?${params}`, {
          signal: controller.signal,
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.detail || payload.error || "Failed to load DIFOT summary");
        }
        const payload = await response.json();
        if (cancelled) return;
        setSummary({
          totalConsignments: Number(payload.totalConsignments) || 0,
          consignmentsQoqPct: Number(payload.consignmentsQoqPct) || 0,
          difotPct: Number(payload.difotPct) || 0,
          difotQoqChange: Number(payload.difotQoqChange) || 0,
          dlRate: Number(payload.dlRate) || 0,
          dlQoqChange: Number(payload.dlQoqChange) || 0,
          totalSpend: Number(payload.totalSpend) || 0,
          spendQoqPct: Number(payload.spendQoqPct) || 0,
          podRate: Number(payload.podRate) || 0,
          podQoqChange: Number(payload.podQoqChange) || 0,
        });
      } catch (err) {
        if (err.name === "AbortError" || cancelled) return;
        setError(err.message || "Failed to load DIFOT summary");
      } finally {
        if (!cancelled) setIsSummaryLoading(false);
      }
    };

    fetchSummary();

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [canLoadData, filters]);

  return { summary, isSummaryLoading, error };
}
